import { isPostResolutionStatus } from '@/lib/market/resolution-hold';

export function shouldFireResolutionFireworks(
  previousStatus: string | null,
  currentStatus: string,
  isDebugOverridden: boolean,
): boolean {
  // A held page presents `trading` straight to `graduated`, so any entry into a
  // post-resolution status celebrates.
  return (
    !isDebugOverridden &&
    previousStatus !== null &&
    !isPostResolutionStatus(previousStatus) &&
    isPostResolutionStatus(currentStatus)
  );
}
